module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewDsaAgreement"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printDsaAgreement()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printDsaAgreement"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                        "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                        ")]), _c('br'), _c('br'), _c('strong', [_vm._v("DSA AGREEMENT")])])]), _vm._v(" "), (_vm.seeRecord.user) ? _c('td', {
    staticClass: "text-right",
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.user.code,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                          Show this if the rendering fails.\n                        ")])], 1) : _vm._e()])]), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "100%"
    }
  }), _vm._v(" "), (_vm.seeRecord.user) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('td', [_c('b', [_vm._v("\n                          " + _vm._s(_vm.seeRecord.user.name) + " "), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.seeRecord.address) + ",")]), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.seeRecord.city) + ",")]), (_vm.seeRecord.state) ? _c('i', [_vm._v(_vm._s(_vm.seeRecord.state.name) + " -")]) : _vm._e(), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.seeRecord.pin))]), _c('br')])]), _vm._v(" "), (_vm.seeRecord.branch) ? _c('td', {
    staticClass: "text-right"
  }, [_vm._v("Branch: " + _vm._s(_vm.seeRecord.branch.name) + " "), _c('br'), _vm._v("Date: " + _vm._s(_vm._f("myDate")(_vm.currDate)))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-center text-bold"
  }, [_vm._v("Sub: Direct Selling Agent Letter")]), _vm._v(" "), _c('p', [_vm._v("Dear "), (_vm.seeRecord.user) ? _c('b', [_vm._v(_vm._s(_vm.seeRecord.user.name))]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("This has reference to your application and subsequent interviews you have had with us. We are pleased to offer you a DSA Agreement in our " + _vm._s(_vm.getCompanyRecord.companyName) + " based at "), (_vm.seeRecord.branch) ? _c('i', [_vm._v("Branch: " + _vm._s(_vm.seeRecord.branch.name))]) : _vm._e(), _vm._v(", with effect from " + _vm._s(_vm._f("myDate")(_vm.seeRecord.joiningDate)) + ", on the following terms and conditions.")]), _vm._v(" "), _c('p', [_vm._v("The Company undertakes Loan disbursement, loan collection and EMI recovery at various locations and you are being engaged for the same, based at "), (_vm.seeRecord.branch) ? _c('i', [_vm._v(_vm._s(_vm.seeRecord.branch.address) + ",")]) : _vm._e(), _vm._v(" on the following terms & conditions:")]), _vm._v(" "), _c('p', {
    staticClass: "text-bold"
  }, [_vm._v("Scope of Work")]), _vm._v(" "), _c('p', [_vm._v("You will be responsible for:")]), _vm._v(" "), _c('p', [_vm._v("Management reserves the right of changing the scope of your work or your posting based on business exigencies.")]), _vm._v(" "), _c('p', {
    staticClass: "text-bold"
  }, [_vm._v("A.\tTerms")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("This contract will be valid for " + _vm._s(_vm.contracttenure) + " with effect from " + _vm._s(_vm._f("myDate")(_vm.seeRecord.joiningDate)) + ".")]), _vm._v(" "), _c('li', [_vm._v(" You are required to pay DSA ID Charge of Rs. " + _vm._s(_vm.consultancyfees) + ".")]), _vm._v(" "), _c('li', [_vm._v(" Your renumeration will be based on the Total Loan Disbursement and Monthly Loan recovery. ")]), _vm._v(" "), _c('li', [_vm._v("You would be reimbursed the cost of any official long distance calls made by you upon submission of bills.")]), _vm._v(" "), _c('li', [_vm._v("You are expected to work for 313 days in a year (exclusive of public holidays & festivities) and you should inform your non availability in advance.")]), _vm._v(" "), _c('li', [_vm._v("During the course of your employment with " + _vm._s(_vm.getCompanyRecord.companyName) + ", you will be required to abide by " + _vm._s(_vm.getCompanyRecord.companyName) + ", code of conduct as detailed out in Annexure A.  Non-compliance to the code of conduct will lead to termination without notice and the management may (depending on the nature of violation) proceed with legal lawsuit.")])]), _vm._v(" "), _c('p', [_vm._v("The contract may be terminated with one month’s notice from either side or on payment of one months salary")]), _vm._v(" "), _c('p', {
    staticClass: "text-bold"
  }, [_vm._v("B. Confidentiality of Information")]), _vm._v(" "), _c('p', [_vm._v("1.\tYou will not divulge information about the company, customer, and progress of the project to any outsider without prior approval from your supervising manager.")]), _vm._v(" "), _c('p', [_vm._v("2.\tYou will not undertake similar assignments from competitors of the " + _vm._s(_vm.getCompanyRecord.companyName) + ", during the course of this contract.")]), _vm._v(" "), _c('p', [_vm._v("You will take utmost care during the course of this contract in handling business information of sensitive nature to maintain its secrecy.")]), _vm._v(" "), _c('p', {
    staticClass: "text-bold"
  }, [_vm._v("C. Reporting")]), _vm._v(" "), _c('p', [_vm._v("You are required to inform the progress of your work to " + _vm._s(_vm.reportingmanager))]), _vm._v(" "), _c('p', [_vm._v("Kindly communicate your acceptance of this contract by signing a copy of this letter and returning it to us.")]), _vm._v(" "), _c('p', [_vm._v("Thanking you.")]), _vm._v(" "), _c('p', [_vm._v("Sincerely, ")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("For "), _c('b', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))])]), _vm._v(" "), _c('p', [_vm._v("Managing Director")]), _vm._v(" "), _c('p', [_vm._v("CC: Accounts Manager")]), _vm._v(" "), _c('p', [_vm._v("Accepted by "), (_vm.seeRecord.user) ? _c('b', [_vm._v(_vm._s(_vm.seeRecord.user.name))]) : _vm._e()]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Signature of the Candidate")]), _vm._v(" "), _c('p', [_vm._v("Date: ")]), _vm._v(" "), _c('p', [_vm._v("Location: ")])]) : _vm._e()])])])]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            CLOSE\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5fff43f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/DsaAgreement.vue
// module id = 879
// module chunks = 0